import * as React from "react";
import PropTypes from 'prop-types';

const SvgPlay = props => {
  if (props.id !== "_svgplay") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path d="M30.59 18.74L9.81 5.24a1.55 1.55 0 00-1.53-.07c-.48.247-.78.741-.78 1.28l.08 27.11a1.43 1.43 0 00.79 1.27 1.51 1.51 0 001.53-.08l20.7-13.61a1.43 1.43 0 000-2.4" /></svg>;
};

SvgPlay.displayName = "_svgplay";
SvgPlay.propTypes = {
  id: PropTypes.string
};
SvgPlay.defaultProps = {
  id: ''
};
export default SvgPlay;